<template>
    <div class="doc-preview">
        <preloader :display="loading" />
        <CompassDialog
            :visible.sync="showModal"
            size="large"
            :title="$t.__('common.labels.document') + ' ' + ident"
            @closed="$emit('close')"
        >
            <template slot="default">
                <div class="dialog__default">
                    <div>
                        <h3 class="dialog__default--actions">{{ $l10n.__('Actions') }}</h3>
                        <ul class="dialog__default--list">
                            <li v-for="(action, index) in actions" :key="index">
                                <CompassLink
                                    :label="action.label"
                                    :link="action.href"
                                    :target="action.target"
                                    class="dialog__default--link"
                                />
                            </li>
                        </ul>
                    </div>
                    <div>
                        <embed v-if="!loading" :src="url" type="application/pdf" />
                    </div>
                </div>
            </template>
        </CompassDialog>
    </div>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';

export default {
    components: {
        Preloader,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        linkedtype: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            showModal: true,
            loading: false,
            url: null,
            ident: null,
            loaded: [],
            actions: [],
            params: {
                id: this.id,
                linkedtype: this.linkedtype,
            },
        };
    },

    created() {
        //handle event when invoice pdf is generated
        EventBus.$on('invoice:generated', (event) => {
            if (event.id == this.id) {
                this.showPdf({
                    id: event.id,
                    path: event.publicLink,
                });
            }
        });

        if (!this.params.id || !this.params.linkedtype) {
            return;
        }

        if (this.loaded[this.params.id]) {
            this.params.path = this.loaded[this.params.id];
        }

        if (this.params.path) {
            this.recompute(this.params);
        } else {
            this.generate(this.params);
        }
    },
    destroyed() {
        EventBus.$off('invoice:generated');
    },
    methods: {
        showPdf(data) {
            this.loading = false;
            this.loaded[data.id] = data.path;
            this.recompute({
                path: data.path,
                id: data.id,
                linkedtype: this.linkedtype,
                ident: this.ident,
            });
        },
        recompute(params) {
            this.actions = [
                {
                    href: '/?_f=' + params.linkedtype + 'Overview&id=' + params.id,
                    target: '_blank',
                    label: Loc.g('Aller sur la fiche du document'),
                },
                {
                    href:
                        'javascript:DocOverview.printFromListing("' +
                        params.linkedtype +
                        '", ' +
                        params.id +
                        ')',
                    target: '_blank',
                    label: Loc.g('Imprimer'),
                },
            ];
            this.url = params.path;
            this.ident = params.ident;
            this.loading = false;
        },

        generate(params) {
            this.loading = true;

            const self = this;
            this.$ajax.get(
                `/rest/documents/` + params.linkedtype + `/` + params.id + `/pdf`,
                {},
                (response) => {
                    if (response.path && response.pdfGenerated) {
                        self.loading = false;
                        self.loaded[response.id] = response.path;
                        self.recompute({
                            path: response.path,
                            id: response.id,
                            linkedtype: response.linkedtype,
                            ident: response.ident,
                        });
                    }
                },
                () => {
                    this.close();
                    self.loading = false;
                    Push.error(this.$l10n.__('Problème lors de la récupération du pdf'));
                },
            );
        },

        close() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.doc-preview {
    .dialog {
        &__default {
            height: calc(870px - 32px);
            display: flex;
            justify-content: space-between;

            &--actions {
                line-height: 24px;
                margin: 0;
            }

            &--list {
                margin-top: 8px;
            }

            &--link {
                margin: 6px 12px;
            }

            embed {
                width: 550px;
                height: 100%;
            }
        }
    }
}
</style>
